import apiCDS from "./apiCDS";
import apiCDSApp from "./apiCDSApp";

/**
 * Manages all requests to the APIs.
 */
export const requests = {
  /**
   * Realiza o cadastro de novo usuário
   * @param name string
   * @param email string
   * @param password string
   * @param phoneNumber string
   * @returns Promise
   */
  async signup(name, email, password, phoneNumber) {
    const { data } = await apiCDSApp.post("/signup", {
      name,
      email,
      password,
      phoneNumber,
    });
    return data;
  },

  /**
   * Busca usuário existente com o email
   * @param {String} email
   * @returns Promise<any>
   */
  async verifyUser(email) {
    return await apiCDSApp.post("/users/verify", {
      email,
    });
  },

  /**
   * Busca dados do usuário logado
   */
  async getUser() {
    return await apiCDSApp.get("/users/me");
  },

  /**
   * Busca detalhes de um curso - endpoint público
   * @param {String} courseId
   * @returns Promise<any>
   */
  async getCourse(courseId) {
    const { data: course } = await apiCDS.get(`/courses/${courseId}`);
    const data = convertData({ course });

    return data;
  },

  /**
   * Busca detalhes do usuário relacionado ao curso - endpoint privado
   * @param {String} courseId
   * @returns Promise<any>
   */
  async getPersonalCourse(courseId) {
    const { data: course } = await apiCDSApp.get(`/courses/${courseId}`);
    const { data: customer } = await apiCDSApp.get(`/courses/${courseId}/user`);

    const data = convertData({ course, customer });

    return data;
  },

  /**
   * Busca detalhes de uma aula
   * @param courseId string
   * @param classId string
   * @returns Promise
   */
  async getClassVideo({ courseId, classId }) {
    const { data } = await apiCDSApp.get(
      `/courses/${courseId}/classes/${classId}`
    );

    return data;
  },

  /**
   * Cria o progresso de uma aula
   * @param courseId string
   * @param classId string
   * @returns Promise<any>
   */
  async createClassProgress({ courseId, classId }) {
    return await apiCDSApp.post(`/users/courses/classes/create`, {
      courseId,
      classId,
    });
  },

  /**
   * Finaliza o progresso da aula
   * @param courseId string
   * @param classId string
   * @returns Promise<any>
   */
  async finishClassProgress({ courseId, classId }) {
    return await apiCDSApp.patch(`/users/courses/classes/finished`, {
      courseId,
      classId,
    });
  },

  /**
   * Atualiza o progresso de uma aula
   * @param courseId string
   * @param classId string
   * @param progress number
   * @returns Promise<any>
   */
  async updateClassProgress({ courseId, classId, progress }) {
    return await apiCDSApp.patch(`/users/courses/classes/progress`, {
      courseId,
      classId,
      progress,
    });
  },
  /**
   * Altera senha do usuário
   * @param {string} newPassword
   * @returns
   */
  async updatePassword(newPassword) {
    return await apiCDSApp.patch("/users/password", {
      newPassword,
    });
  },
};

/**
 * Convert raw response to a semantic data
 * know by the components
 */
const convertData = (raw) => {
  const unifyContents = () => {
    if (!raw.course && !raw.customer) return [];
    if (!raw.customer && !!raw.course) return raw.course.contents;

    const customerContent = raw.customer.contents?.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});

    return raw.course?.contents.map((content) => ({
      ...content,
      ...(customerContent[content.id] || {}),
    }));
  };

  const unifiedContents = unifyContents();

  return {
    id: raw.course.id,
    userCourseId: !!raw.customer && raw.customer.userCourseId,
    slug: raw.course.slug,
    title: raw.course.title,
    description: raw.course.description,
    complementaryFile: raw.course.images.complemantaryFileUrl,
    cover: raw.course.images.coverUrl,
    coverMobile: raw.course.images.coverMobileUrl,
    authorId: raw.course.author.id,
    author: raw.course.author.name,
    authorDescription: raw.course.author.description,
    authorThumb: raw.course.author.images.thumbUrl,
    courseDuration: raw.course.duration,
    classes: raw.course.classes,
    classesFinished: !!raw.customer && raw.customer.classesFinished,
    isFinished: !!raw.customer && raw.customer.isFinished,
    hasAccess: !!raw.customer && raw.customer.hasAccess,
    activeContent:
      unifiedContents.find((video) => video.isFinished === false) ||
      unifiedContents[0],
    contents: unifiedContents,
    categories: raw.course.categories || [],
    playerKey: raw.course.playerKey,
  };
};
